import { render, staticRenderFns } from "./add.dialog.vue?vue&type=template&id=977092e0&scoped=true"
import script from "./add.dialog.vue?vue&type=script&lang=js"
export * from "./add.dialog.vue?vue&type=script&lang=js"
import style0 from "./add.dialog.vue?vue&type=style&index=0&id=977092e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977092e0",
  null
  
)

export default component.exports